import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { I18nModule } from '../../../core/i18n';
import { DatePickerCalendarInputComponent } from './date-picker-calendar-input.component';

@NgModule({
  imports: [CommonModule, NzIconModule, NgbDatepickerModule, I18nModule, FormsModule, NgbModule],
  declarations: [DatePickerCalendarInputComponent],
  exports: [DatePickerCalendarInputComponent],
})
export class DatePickerCalendarInputModule {}
